import classNames from 'classnames';
import { useMemo } from 'react';
import { CheckIcon, PopoverMenuItem } from 'ui';
import { Role } from '../../types';
import { rolesMapping } from '../const';
import { getRoleAppUrl, rolesManipulator } from '../utils';
import { useGetUserRoles } from './useGetUserRoles';

export interface UseGetAppSelectorInfoProps {
  onClickBeforeChangeRole?: () => void;
}

export const useGetAppSelectorInfo = ({
  onClickBeforeChangeRole,
}: UseGetAppSelectorInfoProps = {}): {
  value: string | null;
  items: PopoverMenuItem[];
} => {
  const roles = useGetUserRoles();
  const activeRole = rolesManipulator.current_user_role;

  const items = useMemo(() => {
    return roles
      .filter(role => Object.values(roles).includes(role))
      .map(role => {
        const isActive = role === activeRole && role !== Role.SR_INVESTOR;
        const { app, name } = rolesMapping[role];
        return {
          label: (
            <div className={classNames('flex items-center justify-between w-full gap-4')}>
              <div className={classNames('flex gap-3 items-center', { 'text-gray-500': isActive })}>
                <img src={app.icon} alt={app.shortName} className="w-6 h-6 min-w-6 min-h-6" />
                <div>
                  <div>{app.shortName}</div>
                  <div className="text-xs capitalize">{name}</div>
                </div>
              </div>
              {isActive && (
                <div>
                  <img src={CheckIcon} alt="active" />
                </div>
              )}
            </div>
          ),
          value: role,
          className: classNames('block', {
            'cursor-default hover:!bg-white': isActive,
            'cursor-pointer hover:bg-gray-50': !isActive,
          }),
          onClick: () => {
            if (!isActive) {
              onClickBeforeChangeRole && onClickBeforeChangeRole();
              rolesManipulator.set_current_user_role(role);
              window.open(getRoleAppUrl(role), '_self');
            }
          },
        };
      });
  }, [activeRole, onClickBeforeChangeRole, roles]);

  return {
    value: rolesManipulator.current_user_role,
    items,
  };
};
